export default __webpack_public_path__ + "static/media/Aidquest_logo.a5419d20.png";